import Vue from 'vue';

import { setupHTTP } from './http.boot';
import { setupLang } from './lang.boot';

export async function boot(vueInstance: Vue) {
  try {
    vueInstance.$kit.loading = true;

    setupHTTP(vueInstance);

    await setupLang(vueInstance);
  } catch (e) {
    vueInstance.$kit.loading = false;
    console.error('Error booting app', e);
  } finally {
    vueInstance.$kit.loading = false;
  }

  // eslint-disable-next-line id-match
  // this.$msg = module => (key, token, data) =>
  //   this.i18n(`${module}.${key}${token ? `.${token}` : ''}`, false, null, data);
}
